
import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AlertService } from 'sce-core';
import { SharedServiceRegistry } from './../../../../../../../shared/shared-service-registry';
import { SearchService } from '../../../../../../../shared/search/search.service';
import { ServerPagedTableService } from '../../../../../../../shared/services/table/server-paged-table.service';
import { SearchParams } from '../../../../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../../../../shared/search/models/search-status.model';
import { SearchEvent } from '../../../../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../../../../../shared/search/search-constants';

@Component({
  selector: 'lfwms-cc-search-popup',
  templateUrl: './cc-search-popup.component.html',
  styleUrls: ['./cc-search-popup.component.css']
})
export class CCSearchPopupComponent {

  public lookupParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupService: SearchService;
  public lookupAlertService: AlertService;
  public tableService: ServerPagedTableService;
  public eventSubscription: Subscription;

  constructor(private sharedServiceRegistry: SharedServiceRegistry) {}

  public initializeComponents(lookupParams: any, lookupStatus: any,
      searchService: SearchService, tableService: ServerPagedTableService,
      dataEditor?: any) {
    this.lookupParams = lookupParams;
    this.lookupParams.alertService = this.sharedServiceRegistry.alertService;
    this.lookupParams.tableEditor = dataEditor;
    this.lookupService = searchService;
    this.lookupService.searchParams = lookupParams;
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupService.searchStatus = lookupStatus;
    this.eventSubscription = this.lookupService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          this.sharedServiceRegistry.sceModalService.modalReference.hide();
        }
      });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/cycle-count/stock-take-parameters/cycle-count-home/cycle-count-details/cc-search-popup/cc-search-popup.component.ts